import axios, { addInterceptors } from './interceptor-axios';
import config, { UPLOAD_TYPES } from '~/config';

class ExportService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiExportURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  getExportJobStatus({ jobID, userID }) {
    const request = {
      method: 'GET',
      url: '/exportJob/status',
      params: {
        user_id: userID,
        id: jobID,
      },
    };
    return this.axios(request);
  }

  generateUploadURL({ uploadType, fileName }) {
    const request = {
      method: 'POST',
      url: '/uploadURL',
      data: {
        uploadType,
        fileName,
      },
    };
    return this.axios(request);
  }

  async uploadJobInput(jsonData) {
    const { result } = await this.generateUploadURL({
      uploadType: UPLOAD_TYPES.JOB_INPUT,
    });
    console.log('result', result);
    const blobObj = new Blob([JSON.stringify(jsonData)], {
      type: 'application/json',
    });
    const options = {
      headers: {
        'Content-Type': blobObj.type,
      },
      isForUploadS3: true,
    };
    await this.axios.put(result.uploadURL, blobObj, options);
    return result.uploadKey;
  }

  addExportJob({
    userID,
    designID,
    action,
    inputKey,
    colorMode,
    iccProfileKey,
    options,
    totalPages,
  }) {
    const request = {
      method: 'POST',
      url: '/exportJob',
      data: {
        user_id: userID,
        design_id: designID,
        action,
        inputKey,
        colorMode,
        iccProfileKey,
        options,
        totalPages,
      },
    };
    return this.axios(request);
  }

  addJobToExportPDF({
    userID,
    designID,
    action,
    pageIndexes,
    colorMode,
    iccProfileKey,
    options,
    totalPages,
  }) {
    const request = {
      method: 'POST',
      url: '/exportJob/pdf',
      data: {
        user_id: userID,
        design_id: designID,
        action,
        pageIndexes,
        colorMode,
        iccProfileKey,
        options,
        totalPages,
      },
    };
    return this.axios(request);
  }

  recordExportImageJob({
    userID,
    designID,
    action,
    status,
    totalPages,
    duration,
    options,
    error,
  }) {
    const request = {
      method: 'POST',
      url: '/record-export-image-job',
      data: {
        user_id: userID,
        design_id: designID,
        action,
        options,
        status,
        total_pages: totalPages,
        duration,
        error,
      },
    };
    return this.axios(request);
  }
}

export default new ExportService();
